import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import React, {Component} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styles from './css/Certificate.scss';
import Bar from "../../../ui/Bar";

@injectIntl
export default class CertificateEntry extends Component {
    static propTypes = {
        intl: intlShape,
        user: ImmutablePropTypes.map.isRequired,
    }

    renderLocationInfo() {
        const {entry} = this.props;
        return entry && (
            <address className={styles.section}>
                <h3 className={styles.heading}>
                    <FormattedMessage id='frontend.form_selector_shipping.label.number'/>
                    {' #'}{entry.getIn(['location', 'number'])}
                    {entry.getIn(['location', 'old_number']) && (
                        <small>( {entry.getIn(['location', 'old_number'])})</small>
                    )}
                </h3>
                <ul className={styles.details}>
                    <li>
                        {entry.getIn(['location', 'address', 'organization'])}
                    </li>
                    <li>
                        {entry.getIn(['location', 'contact'])}
                    </li>
                    <li>
                        {entry.getIn(['location', 'address', 'phone'])}
                    </li>
                    <li>
                        {entry.getIn(['location', 'address', 'email'])}
                    </li>
                </ul>
            </address>
        );
    }

    renderCertificates() {
        const {entry} = this.props;
        return entry && entry.get('months') && (
            <address className={styles.section}>
                <h3 className={styles.heading}>
                    <FormattedMessage id='frontend.certificate.headline.download'/>
                </h3>
                <ul className={styles.details}>
                    {entry.get('months').map(month => {
                        const link = month.get('url');
                        return (<li key={month.get('period')}>
                            <a href={link}>
                                <div><i className='fa fa-download'/>{' ' + month.get('period')}</div>
                            </a>
                        </li>)
                    }).toArray()}
                </ul>
            </address>
        );
    }

    render() {
        const {entry} = this.props;
        if (!entry) return null;

        return (
            <div className={styles.entry}>
                <Bar.Section float='left'>
                    {this.renderLocationInfo()}
                    {this.renderCertificates()}
                </Bar.Section>
            </div>
        );
    }
}
